import { useState } from 'react';
import { CLUB, MLP, USDT, wallets } from '../../../../helpers/helperFunctions';
import {
  ArrowPolygon,
  Flexed,
  Select
} from '../../../../styles/GlobalComponents';
import { color } from '../../../../styles/GlobalStyles';
import {
  Icon,
  IconSettingsCheckboxOff,
  IconSettingsCheckboxOn
} from '../../../../styles/Icons';
import { SectionSeparator } from '../../../../styles/stylesStyled';

import { CollapsibleAbsolute, SelectDropDown } from './SelectFunds.styles';

interface SelectFromFundsProps {
  setSelectedFund: (fund: string) => void;
  setSelectedReceived: (fund: string) => void;
  selectedFund: string;
}

interface SelectToFundsProps {
  setSelectedFund: (fund: string) => void;
  setSelectedReceived: (fund: string) => void;
  selectedReceived: string;
}

const sendFrom: string[] = [USDT, CLUB];

const sendTo: string[] = [CLUB, MLP];

export const SelectFromFunds = ({
  setSelectedReceived,
  selectedFund,
  setSelectedFund
}: SelectFromFundsProps) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  return (
    <Select
      isOpen={isOpenDropdown}
      onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
      <span>
        {selectedFund ? (
          <Flexed center>
            <span>{selectedFund}</span>
          </Flexed>
        ) : (
          <div style={{ color: color.colors.neutral700 }}>{selectedFund}</div>
        )}
      </span>

      <ArrowPolygon
        direction={isOpenDropdown ? 'down' : 'right'}
        customColor={color.colors.neutral700}
      />

      <CollapsibleAbsolute isOpen={isOpenDropdown}>
        <SelectDropDown>
          {sendFrom.map((fund, index) => {
            return (
              <div key={index}>
                <Flexed
                  between
                  onClick={() => {
                    setSelectedFund(fund);
                    if (fund === CLUB) {
                      setSelectedReceived(sendTo[1]);
                    }

                    setIsOpenDropdown(!isOpenDropdown);
                  }}
                  key={index}
                  style={{ width: '100%' }}>
                  <Flexed center>
                    <span>{fund}</span>
                  </Flexed>
                  <Icon color={color.colors.secondary100}>
                    {selectedFund === fund ? (
                      <IconSettingsCheckboxOn size={'24'} />
                    ) : (
                      <IconSettingsCheckboxOff size={'24'} />
                    )}
                  </Icon>
                </Flexed>
                <SectionSeparator margin='0' />
              </div>
            );
          })}
        </SelectDropDown>
      </CollapsibleAbsolute>
    </Select>
  );
};

export const SelectToFunds = ({
  setSelectedFund,
  selectedReceived,
  setSelectedReceived
}: SelectToFundsProps) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  return (
    <Select
      isOpen={isOpenDropdown}
      onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
      <span>
        {selectedReceived ? (
          <Flexed center>
            <span>{selectedReceived}</span>
          </Flexed>
        ) : (
          <div style={{ color: color.colors.neutral700 }}>
            {selectedReceived}
          </div>
        )}
      </span>

      <ArrowPolygon
        direction={isOpenDropdown ? 'down' : 'right'}
        customColor={color.colors.neutral700}
      />

      <CollapsibleAbsolute isOpen={isOpenDropdown}>
        <SelectDropDown>
          {sendTo.map((fund, index) => {
            return (
              <div key={index}>
                <Flexed
                  between
                  onClick={() => {
                    setSelectedReceived(fund);
                    if (fund === CLUB) {
                      setSelectedFund(sendFrom[0]);
                    }
                    setIsOpenDropdown(!isOpenDropdown);
                  }}
                  key={index}
                  style={{ width: '100%' }}>
                  <Flexed center>
                    <span>{fund}</span>
                  </Flexed>
                  <Icon color={color.colors.secondary100}>
                    {selectedReceived === fund ? (
                      <IconSettingsCheckboxOn size={'24'} />
                    ) : (
                      <IconSettingsCheckboxOff size={'24'} />
                    )}
                  </Icon>
                </Flexed>
                <SectionSeparator margin='0' />
              </div>
            );
          })}
        </SelectDropDown>
      </CollapsibleAbsolute>
    </Select>
  );
};
